// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"0407bc1b","211":"47aa83f8","344":"f374cf5d","634":"28802458","683":"0076925d","787":"6034518f","938":"c657d944"}[chunkId] + ".chunk.js";
};